import { TextField } from "@mui/material";

export default function SmallInput(props: any) {
  return (
    <TextField
      {...props}
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          height: 38,
          borderRadius: "10px",
        },
        "& .MuiInputBase-input": {
          padding: "6px 12px",
          fontSize: "12px",

          "&::placeholder": {
            color: "#4b5563", // más oscuro
            opacity: 1, // importante para que respete el color
          },
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#7a7a7a", // texto disabled más oscuro
          color: "#7a7a7a",

          "&::placeholder": {
            WebkitTextFillColor: "#4b5563",
            color: "#4b5563",
            opacity: 1,
          },
        },
        ...props.sx
      }}
    />
  );
}
